// extracted by mini-css-extract-plugin
export var whoWeAre = "who-we-are-module--whoWeAre--3U5Dr";
export var row = "who-we-are-module--row--DyjkT";
export var column = "who-we-are-module--column--SiC1u";
export var media = "who-we-are-module--media--2ur0Q";
export var giantTwelve = "who-we-are-module--giantTwelve--39Cf9";
export var inView = "who-we-are-module--inView--3YL3c";
export var copy = "who-we-are-module--copy--1V3YR";
export var link = "who-we-are-module--link--2vn0b";